import * as ROUTES from '#client/constants/routes';

export const VELO_SIDE_PANEL_SOURCE_COMPONENT = 'velo-side-panel';

export const VELO_SIDE_PANEL_CLICKSTREAM_POSITION = 'velo_side_panel';

export const VELO_SIDE_PANEL_TOP_BAR_HEIGHT = '4.25rem';

export const VELO_SIDE_PANEL_PAGES = [
  {
    path: ROUTES.entityComplianceHub,
    promptSet: 'compliance-hub',
    tag: 'COMPLIANCE.overview.default',
    origination: 'compliance-ui-overview',
  },
  {
    path: ROUTES.entityComplianceAmendments,
    promptSet: 'compliance-amendments',
    tag: 'COMPLIANCE.amendments.default',
    origination: 'compliance-ui-amendments',
  },
  {
    path: ROUTES.entityComplianceAnnualReports,
    promptSet: 'compliance-annual-reports',
    tag: 'COMPLIANCE.annualReports.default',
    origination: 'compliance-ui-annual-reports',
  },
  {
    path: ROUTES.entityComplianceBusinessLicenses,
    promptSet: 'compliance-business-licenses',
    tag: 'COMPLIANCE.businessLicenses.notPurchased',
    origination: 'compliance-ui-business-licenses',
  },
  {
    path: ROUTES.entityComplianceRegisteredAgent,
    promptSet: 'compliance-registered-agent',
    tag: 'COMPLIANCE.registeredAgent.default',
    origination: 'compliance-ui-registered-agent',
  },
  {
    path: ROUTES.entityComplianceTrademarks,
    promptSet: 'compliance-trademarks',
    tag: 'COMPLIANCE.trademarks.default',
    origination: 'compliance-ui-trademarks',
  },
  // These sections have no chips of their own yet, so they reuse the compliance overview's.
  {
    path: ROUTES.entityComplianceBeneficialOwnership,
    promptSet: 'compliance-hub',
    tag: 'COMPLIANCE.overview.default',
    origination: 'compliance-ui-beneficial-ownership',
  },
  {
    path: ROUTES.entityComplianceMeetingMinutes,
    promptSet: 'compliance-hub',
    tag: 'COMPLIANCE.overview.default',
    origination: 'compliance-ui-meeting-minutes',
  },
  {
    path: ROUTES.entityCompliancePremiumSupport,
    promptSet: 'compliance-hub',
    tag: 'COMPLIANCE.overview.default',
    origination: 'compliance-ui-premium-support',
  },
  {
    path: ROUTES.entityComplianceTrademarkSearchResults,
    promptSet: 'compliance-hub',
    tag: 'COMPLIANCE.overview.default',
    origination: 'compliance-ui-trademark-search-results',
  },
  {
    path: ROUTES.entityFinanceHub,
    promptSet: 'finance-hub',
    tag: 'FINANCE.overview.default',
    origination: 'finance-ui-overview',
  },
  {
    path: ROUTES.entityMarketingToolsHub,
    promptSet: 'marketing-hub',
    tag: 'MARKETING.overview.default',
    origination: 'marketing-ui-overview',
  },
];
